import { Box, Tooltip } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';

import { formatLigaName } from '../../utils/UtilesComun';
import Clasificacion from '../ligas/Clasificacion';

const ClasificacionWrapper = ({ clasificacion, idEquipoResaltado, datosLiga }) => {
  if (!clasificacion || !datosLiga) {
    return null;
  }

  const nombreLiga = formatLigaName(datosLiga.categoria, datosLiga.division, datosLiga.grupo);

  const cabeceraLiga = (
    <Tooltip title="Ver liga" arrow>
      <Box
        component={Link}
        to={`/liga/${datosLiga.idLiga}`}
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          textDecoration: 'none',
          color: 'inherit',
          fontWeight: 700,
          fontSize: '0.88rem',
          cursor: 'pointer',
          py: 0.25,
          px: 1,
          borderRadius: '4px',
          transition: 'all 0.15s ease-in-out',
          '&:hover': {
            color: 'primary.main',
            backgroundColor: 'rgba(15, 118, 110, 0.08)',
          },
        }}
      >
        {nombreLiga}
      </Box>
    </Tooltip>
  );

  return (
    <Clasificacion
      clasificacion={clasificacion}
      idEquipoResaltado={idEquipoResaltado}
      embedded={true}
      title={cabeceraLiga}
    />
  );
};

ClasificacionWrapper.propTypes = {
  clasificacion: PropTypes.array,
  idEquipoResaltado: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  datosLiga: PropTypes.object,
};

export default ClasificacionWrapper;
